import { Box } from '@mui/material'
import { FC } from 'react'
import { RewardsResponse } from '../../../RewardService/types'

interface RewardProps {
    challenge: RewardsResponse['challenges'][0]
    isClaimable: boolean
}

export const Reward: FC<RewardProps> = ({ challenge: { progress, assetUrl }, isClaimable }) => {
    const borderColor = progress ? (isClaimable ? 'secondary.main' : 'primary.main') : 'common.white'

    return (
        <Box
            className="reward"
            sx={{
                width: { xs: '80px', md: '140px' },
                height: { xs: '80px', md: '140px' },
                aspectRatio: '1/1',
                gridArea: 'icon',
                border: '2px solid',
                position: 'relative',
                borderRadius: '6px',
                borderColor,
                padding: { xs: 0.5, md: 1 },
                ml: { xs: 0, md: 2 },
                overflow: 'hidden',
            }}
        >
            {isClaimable && (
                <Box
                    sx={{
                        zIndex: 1,
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        backgroundImage: `url(/assets/animations/rewards/rays.svg)`,
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        animation: 'rotate 20s linear infinite',
                        '@keyframes rotate': {
                            '0%': { transform: 'rotate(0deg)' },
                            '100%': { transform: 'rotate(360deg)' },
                        },
                    }}
                />
            )}
            <Box
                className="reward-asset"
                sx={{
                    width: '100%',
                    height: '100%',
                    backgroundImage: `url(${assetUrl})`,
                    backgroundSize: 'contain',
                    zIndex: 2,
                    borderRadius: 0,
                    position: 'relative',
                }}
            />
        </Box>
    )
}
